import { useNavigate, useSearchParams } from "react-router-dom";
import { useContextSite } from "../../../context/Context";
import { IClienteAtualizarForm, IClienteDTO } from "../../../types/cliente";
import { Cliente } from "../../../services/Cliente";
import { toast } from "react-toastify";
import { removerCaracteresEspeciais } from "../../../utils/masks";

export const useClientDetail = () => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const navigate = useNavigate();
  const { setIsLoad } = useContextSite();

  function submitForm(data: IClienteDTO) {
    setIsLoad(true);
    const PAYLOAD: IClienteAtualizarForm = {
      ...data,
      cpfCnpj: removerCaracteresEspeciais(data.cpfCnpj),
      uuid: id,
    };

    Cliente.atualizar(PAYLOAD)
      .then(() => {
        toast.success("Dados atualizados com sucesso");
        setTimeout(() => {
          navigate("/configuracoes/clientes");
        }, 1500);
      })
      .catch(
        ({
          response: {
            data: { messagem },
          },
        }) => toast.error(messagem)
      )
      .finally(() => {
        setIsLoad(false);
      });
  }

  return { submitForm };
};
